import * as React from 'react'
import * as styles from './LiveBadge.module.scss'
import BasicBadge from './BasicBadge'
import * as cn from 'classnames'

interface LiveBadgeProps {
  label: string
  status: string
  isStandalone?: boolean
}

const LiveBadge = ({ label, status, isStandalone }: LiveBadgeProps) => {
  if (!status || !label) {
    return null
  }
  const classNames = cn([{ [styles.isStandalone]: isStandalone }, styles.LiveBadge])
  return (
    <BasicBadge className={classNames}>
      {label}
    </BasicBadge>
  )
}

export default LiveBadge
